import { SlideItemType } from '../enums';
import { QuestionSlideItemType } from '../zod/slideTypes/questionSlideSchema';
import { TextAnswerSlideItemType } from '../zod/slideTypes/slideItemTypes/answerSlideItemTypes/textAnswerSlideItemSchema';

export default function isSlideItemTextAnswerItem(
  item: QuestionSlideItemType
): item is TextAnswerSlideItemType {
  return item.type === SlideItemType.ANSWER_TEXT;
}
